export default {
  methods: {
    getProductItemField(productId, productItemId, field) {
      const product = this._.find(this.products, {id: productId + ''});
      const productItem = product ? this._.find(product.items,
          {id: productItemId + ''}) : null;

      return productItem ? productItem[field] : '';
    },
    edit(albumId, uuid, set = false, tag = null) {
      this.$store.dispatch('SET_UUID', uuid);

      if (set) {
        this.$store.dispatch('SET_REPLACED_PHOTO_PRODUCT', false);
        this.$store.commit('SET_SET', set);

        this.$router.push(`album/gallery/${albumId}#set${tag ? `?tag=${tag}` : ''}`);
      } else {
        this.$router.push(`album/gallery/${albumId}/order${tag ? `?tag=${tag}` : ''}`);
      }
    },
    remove(index, parentIndex) {
      this.$store.dispatch('DELETE_PRODUCT', {index, parentIndex});
    },
    getAlbumId(album) {
      if (album.album_status === '2') {
        return `${album.album_hash}-${album.album_hash_password}`;
      }

      return album.album_id;
    },
    reloadProductTotal(data) {
      const productRowEl = document.getElementById(`total-${data.parentIndex}-${data.index}`);

      if (productRowEl && productRowEl.innerHTML !== this.$options.filters.currency(data.total)) {
        productRowEl.innerHTML = this.$options.filters.currency(data.total);
      }
    }
  },
};
